/**
 * Assignment Flow Store
 * Manages state for cross-section navigation during assignment completion workflow
 * Used when creating job cards for vehicles with active assignments
 */

import { create } from 'zustand';
import type { Vehicle } from '../types';

interface AssignmentFlowData {
  assignmentId: string;
  vehicleId: string;
  driverId: string;
  driverName: string;
  secondaryDriverId?: string;
  isSharedAssignment?: boolean;
}

interface AssignmentFlowState {
  // Pending assignment data
  pendingAssignment: {
    vehicle: Vehicle;
    assignmentData: AssignmentFlowData;
    returnToJobCard: boolean;
  } | null;

  // Actions
  setPendingAssignment: (
    vehicle: Vehicle,
    assignmentData: AssignmentFlowData
  ) => void;
  clearPendingAssignment: () => void;
  hasPendingAssignment: () => boolean;
}

export const useAssignmentFlowStore = create<AssignmentFlowState>((set, get) => ({
  pendingAssignment: null,

  setPendingAssignment: (vehicle, assignmentData) => {
    console.log('🔄 Setting pending assignment in store:', {
      vehicle: vehicle.licensePlate,
      assignmentId: assignmentData.assignmentId,
      driverName: assignmentData.driverName,
    });
    
    set({
      pendingAssignment: {
        vehicle,
        assignmentData,
        returnToJobCard: true,
      },
    });
  },

  clearPendingAssignment: () => {
    console.log('🧹 Clearing pending assignment from store');
    set({ pendingAssignment: null });
  },

  hasPendingAssignment: () => {
    return get().pendingAssignment !== null;
  },
}));
